import { useEffect, useState } from "react";
import { api, puede, enviarMensajeAhora, ErrorApi } from "../api.ts";
import { leerCache, guardarCache } from "../cache.ts";

interface Cumple { id: string; hc: number; nombre: string; fecha: string; enDias: number; cumple: number | null; menor: boolean; representante: string; celular: string; correo: string; aceptaPromociones: boolean; estado: "" | "enviado" | "por_enviar"; enviadoEn: string | null }
interface Datos { pacientes: Cumple[] }

const cuando = (n: number) => (n === 0 ? "¡Hoy!" : n === 1 ? "Mañana" : n > 1 ? `En ${n} días` : n === -1 ? "Ayer" : `Hace ${-n} días`);

/**
 * Tarjeta de la página de inicio con los cumpleaños de hoy, de los próximos 7 días y de los últimos 3 (para no dejar a nadie sin felicitar por descuido).
 * Cada uno se felicita con un clic (WhatsApp Business o WhatsApp con el mensaje listo). No aparece si nadie cumple años en ese período.
 */
export function CumpleanosInicio({ ir }: { ir: (ruta: string) => void }) {
  const [lista, setLista] = useState<Cumple[] | null>(() => leerCache<Cumple[]>("inicio.cumples") ?? null);
  const [aviso, setAviso] = useState("");
  const [error, setError] = useState("");
  const escribe = puede("agenda:escribir");
  const cargar = () => api<Datos>("GET", "/api/cumpleanos?dias=7&atras=3").then((r) => setLista(guardarCache("inicio.cumples", r.pacientes))).catch(() => undefined);
  useEffect(() => { cargar(); }, []);

  async function felicitar(p: Cumple, repetir = false) {
    if (repetir && !confirm(`${p.nombre} ya recibió la felicitación de este año. ¿Enviarla otra vez?`)) return;
    try {
      const r = await enviarMensajeAhora(`/api/pacientes/${p.id}/felicitar`, { repetir });
      setAviso(r.enviado ? `Felicitación enviada a ${p.nombre} por ${r.canal === "whatsapp" ? "WhatsApp" : "correo"}.` : `Se abrió ${r.canal === "whatsapp" ? "WhatsApp" : "el correo"} con la felicitación para ${p.nombre}: solo toca Enviar.`);
      setError(""); cargar();
    } catch (e) {
      if (e instanceof ErrorApi && /Ya se le envi/.test(e.message)) return felicitar(p, true);
      setError(e instanceof Error ? e.message : "No se pudo enviar la felicitación.");
    }
  }

  if (!lista || !lista.length) return null;
  const faltan = lista.filter((p) => p.enDias <= 0 && p.estado !== "enviado").length;
  return (
    <section className="card" aria-labelledby="t-cumples">
      <div className="fila" style={{ justifyContent: "space-between", alignItems: "baseline", flexWrap: "wrap", gap: 8 }}>
        <h2 id="t-cumples" style={{ margin: 0 }}>🎂 Cumpleaños</h2>
        {faltan > 0 ? <span className="chip rojo">{faltan === 1 ? "1 sin felicitar" : `${faltan} sin felicitar`}</span> : <span className="chip azul">Al día</span>}
      </div>
      {aviso && <div className="aviso ok" role="status">{aviso}</div>}
      {error && <div className="aviso error" role="alert">{error}</div>}
      <ul className="lista-abonos">
        {lista.map((p) => (
          <li key={p.id} className="cumple">
            <div className="fila" style={{ justifyContent: "space-between", alignItems: "baseline" }}>
              <span><button className="enlace" onClick={() => ir(`paciente/${p.id}`)}><b>{p.nombre}</b></button>{p.cumple !== null && <span className="muted"> · {p.cumple} año{p.cumple === 1 ? "" : "s"}</span>}</span>
              <span style={{ fontWeight: p.enDias <= 0 ? 700 : 400 }}>{cuando(p.enDias)}</span>
            </div>
            <div className="fila" style={{ alignItems: "center", flexWrap: "wrap", gap: 8 }}>
              {p.estado === "enviado" ? <span className="chip azul">Felicitado{p.enviadoEn ? ` el ${new Date(p.enviadoEn).toLocaleDateString("es-EC", { day: "numeric", month: "short" })}` : ""}</span>
                : p.estado === "por_enviar" ? <span className="chip rojo">Felicitación por enviar</span>
                : p.enDias <= 0 ? <span className="chip rojo">Falta felicitar</span> : null}
              {escribe && (p.aceptaPromociones && (p.celular || p.correo)
                ? <button className="btn chico wa" onClick={() => felicitar(p, p.estado === "enviado")}>{p.estado === "enviado" ? "Felicitar otra vez" : p.celular ? "Felicitar por WhatsApp" : "Felicitar por correo"}</button>
                : <span className="muted" style={{ fontSize: 13 }}>{p.aceptaPromociones ? "Sin celular ni correo: agrégalo en su ficha." : "Pidió no recibir promociones."}</span>)}
            </div>
          </li>
        ))}
      </ul>
      <div><button className="btn chico" onClick={() => ir("mensajes/cumpleanos")}>Ver todos los cumpleaños</button></div>
    </section>
  );
}
